export const createEnum = (definition: any) => {
  const strToValueMap: any = {};
  const numToDescMap: any = {};
  Object.keys(definition).forEach((enumName) => {
    const [value, desc] = definition[enumName];
    strToValueMap[enumName] = value;
    numToDescMap[value] = desc;
  });
  return {
    ...strToValueMap,
    getDesc(enumName: any) {
      return definition[enumName][1] ?? '';
    },
    getDescFromValue(value: any) {
      return numToDescMap[value] || '';
    },
  };
};
